import create from './create';
import list from './list';
import deleteCompany from './delete';
import addToFavorite from './addToFavorite';
import exportXlsx from './exportXlsx';
import getFavoriteOwnerList from './getFavoriteOwnerList';

export default [create, list, deleteCompany, addToFavorite, exportXlsx, getFavoriteOwnerList];
